module.exports = __webpack_public_path__ + "media/svg/forbes-66618092.svg";